import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IWithdrawalsHistoryListItem } from '../types';
import {
  WITHDRAWALS_HISTORY_LIST_API_URL,
  WITHDRAWALS_HISTORY_LIST_QUERY_KEY,
  WITHDRAWALS_HISTORY_PERMISSIONS,
} from '../constants';

export default function useWithdrawalsHistoryListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IWithdrawalsHistoryListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IWithdrawalsHistoryListItem>>({
    queryKey: [WITHDRAWALS_HISTORY_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IWithdrawalsHistoryListItem>>(
      WITHDRAWALS_HISTORY_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: WITHDRAWALS_HISTORY_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
